<template>
  <div class="askcontainer">
    <div class="left max_height">
      <div class="title">搜索记录</div>
      <el-timeline v-loading="history_load">
        <el-timeline-item v-for="(item, index) in historylist" :key="index" :timestamp="item.createtime" :class="[selectedIndex == index ? 'selected' : '', !answertrue ? 'disabled-item' : '']" @click.native="answertrue && getask(item.conversation_id, item.question, index)">
          <span class="asklist" @click="getask(item.conversation_id, item.question, index)">{{ item.question }}</span>
        </el-timeline-item>
      </el-timeline>
    </div>
    <div class="middle">
      <div class="message" ref="box">
        <div class="questionContent">
          <div>您的问题：</div>
          <span>{{ questionContent }}</span>
        </div>
        <div class="processContent" v-if="processContent">
          <div v-loading="process_load" element-loading-custom-class="custom-loading"></div>
          <markdown :source="processContent"></markdown>
        </div>
        <div class="searchContent">
          <markdown :source="searchContent"></markdown>
        </div>
        <!-- <div class="referenceContent">
          <markdown :source="referenceContent"></markdown>
        </div> -->
        <div class="search-title" v-if="thinkContent">检索过程</div>
        <div class="thinkContent" v-if="thinkContent" ref="thinkContent">
          <markdown :source="thinkContent"></markdown>
          <!-- <div v-safe-html="thinkContent"></div> -->
          <!-- <component
            v-for="(item, index) in thinkContent"
            :key="index"
            :is="item.component || 'span'"
            v-bind="item.props || {}"
          >
            {{ typeof item === "string" ? item : "" }}
          </component> -->
        </div>
        <div class="answerContent" v-if="answerContent" ref="answerContent">
          <markdown :source="answerContent"></markdown>
        </div>
        <div class="tip_title" v-if="hotlist">相关学术检索</div>
        <div class="tip_qustion">
          <div v-for="(item, index) in hotlist" :key="index" class="tip_list">
            <span @click="toSearch(item)">{{ item }}</span>
          </div>
        </div>
      </div>
      <div class="askinput" v-if="answertrue">
        <el-input placeholder="请输入要检索的内容" v-model="keyword" maxlength="500" @keyup.enter.native="toSearch()" clearable></el-input>
        <i class="serachbtn" @click="toSearch()"><img src="../../assets/images/sousuo.png" /></i>
      </div>
    </div>
    <div class="right max_height">
      <div class="title">参考文献</div>
      <div v-if="referenceContent.length > 0 || reference_load" v-loading="reference_load">
        <ul v-for="(item, index) in referenceContent" :key="index" v-loading="reference_load">
          <li class="booktitle" v-if="item.title" @click="tourl(item.url)">
            {{ item.title }}
          </li>
          <li class="listtext">
            <span>{{ item.author }}</span>
            <span>{{ item.language }}</span>
            <span>{{ item.publish_date }}</span>
          </li>
          <li class="description line5">{{ item.description }}</li>
          <!-- <li class="url" v-if="item.url" @click="tourl(item.url)">
          {{ item.url }}
        </li> -->
        </ul>
      </div>
      <div v-else>暂无相关文献</div>
    </div>
  </div>
</template>

<script>
import "../../styles/AiAnswers.scss";
import Markdown from "vue-markdown";
import markdownit from "markdown-it";
import ReferPopover from "@/components/ReferPopover.vue";
import baseurl from "../../api/baseurl";
export default {
  data() {
    return {
      historylist: [],
      reference: "",
      askthinking: "",
      askload: false,
      keyword: "",
      timer: "",
      askword: "",
      hotlist: "",
      askanswer: "",
      questionContent: "",
      processContent: "",
      searchContent: "",
      referenceContent: [],
      thinkContent: "",
      answerContent: "",
      selectedIndex: "",
      question: "",
      isScrollingUp: false, // 标记是否正在向上滚动
      scrollTimer: null, // 滚动定时器
      history_load: true,
      reference_load: true,
      process_load: true,
      isScrolling: false,
      username: "",
      answertrue: false,
    };
  },
  components: { Markdown, markdownit, ReferPopover },
  mounted() {
    this.getInfo();
    // this.answer();
    // let question = "什么是用于无车道交通的二维LWR模型？";

    //this.history(); // 更新历史记录
    // 监听鼠标滚轮事件
    const box = this.$refs.box;
    if (box) {
      box.addEventListener("scroll", this.updateHidetextPosition);
      // 保留原有的wheel监听
      box.addEventListener("wheel", this.handleScroll);
    }
  },
  beforeDestroy() {
    const box = this.$refs.box;
    if (box) {
      box.removeEventListener("scroll", this.updateHidetextPosition);
      box.removeEventListener("wheel", this.handleScroll);
    }
  },
  methods: {
    handleScroll() {
      this.isScrolling = true;
      // clearTimeout(this.scrollTimer);
      // this.scrollTimer = setTimeout(() => {
      //   this.isScrolling = false;
      // }, 300);
    },
    stream_chat() {
      this.hotlist = "";
      this.reference_load = true;
      this.process_load = true;
      this.isScrolling = false;
      if (sessionStorage.getItem("search-answers")) {
        const raw = sessionStorage.getItem("search-answers");
        this.question = JSON.parse(raw); // 这里会自动去除外层引号
      } else {
        this.answertrue = true;
        return;
      }
      let url = baseurl.baseUrl + "api/v1/resource/ai-academic/stream";
      let token = localStorage.getItem("jyx_token");
      const eventSource = new EventSource(url + "?token=" + token + "&question=" + this.question);
      // 使用箭头函数保持 this 指向 Vue 实例
      eventSource.onmessage = event => {
        const message = JSON.parse(event.data);
        const content = message.content;

        if (content.includes("[question]")) {
          this.questionContent = content.replace("[question]", "");
        } else if (content.includes("[process]")) {
          //处理进度
          this.processContent = content.replace("[process]", "");
          this.askload = false;
        } else if (content.includes("[search]")) {
          //检索结果
          let searchtext = content.replace("[search]", "");
          this.searchContent += searchtext;
        } else if (content.includes("[reference]")) {
          //参考
          const jsonStr = content.replace("[reference]", "");
          try {
            let referencetext = JSON.parse(jsonStr); // 将 JSON 字符串转换为数组
            this.referenceContent = [...this.referenceContent, ...referencetext];
          } catch (error) {
            console.error("JSON 解析出错:", error);
          }
          this.reference_load = false;
        } else if (content.includes("[think]")) {
          this.process_load = false;
          //思考过程
          let thinktext = content.replace("[think]", "");
          this.thinkContent += thinktext;
        } else if (content.includes("[answer]")) {
          //答案
          let answertext = content.replace("[answer]", "");
          if (answertext.includes("</answer_finished>")) {
            let newanswertext = answertext.replace("</answer_finished>", "");
            this.answerContent += newanswertext;
            this.answertrue = true;
            this.wantask();
            setTimeout(() => {
              this.history();
              this.history_load = false;
            }, 2000); // 添加2秒延迟

            this.reference_load = false;
            this.process_load = false;
            // 监听错误事件
            eventSource.onerror = function (error) {
              console.error("EventSource failed:", error);
              eventSource.close(); // 关闭连接
              this.answertrue = true;
            };
            sessionStorage.removeItem("search-answers");
            this.linktext();
          } else {
            this.answerContent += answertext;
          }
        }
        this.scrolldown();
      };
    },
    linktext() {
      if (this.thinkContent) {
        const regex = /refer(\d+)/g;
        // let match;
        this.thinkContent = this.thinkContent.replace(regex, (match, indexStr) => {
          const middleText = parseInt(indexStr, 10) - 1;
          const author = this.referenceContent[middleText]?.author?.slice(0, 5) || "";
          const date = this.referenceContent[middleText]?.publish_date?.split("-")[0] || "";
          const replaceText = author + "..." + date;
          const replacetitle = this.referenceContent[middleText]?.title;
          const replaceauthor = this.referenceContent[middleText].author ? this.referenceContent[middleText].author : "";
          const replaceurl = this.referenceContent[middleText]?.url;
          const replacelanguage = this.referenceContent[middleText].language ? this.referenceContent[middleText].language : "";
          const replacedate = this.referenceContent[middleText].publish_date ? this.referenceContent[middleText].publish_date : "";
          const replacdescription = this.referenceContent[middleText]?.description;
          // const popoverHtml = `<div class='show' @mouseenter="positionHidetext">
          //   <span class='linecolor'>${replaceText}</span>
          //   <div class="hidetext" :style="{ top: hidetextTop + 'px', left: hidetextLeft + 'px' }">
          //     <p class="title" data-url="${replaceurl}">${replacetitle}</p>
          //     <p class="detail">
          //       <span class='line2' style='padding-right:5px;font-weight: normal;'>${replaceauthor}</span>
          //       <span style='padding-right:5px'>${replacelanguage}</span>
          //       <span>${replacedate}</span>
          //     </p>
          //     <p class="description">${replacdescription}</p>
          //   </div>
          // </div>`;
          const popoverHtml = `<div class='show'><span class='linecolor'>${replaceText}</span><div class="hidetext"><p class="title" data-url="${replaceurl}">${replacetitle}</p><p class="detail"><span class='line2' style='padding-right:5px;font-weight: normal;'>${replaceauthor}</span><span style='padding-right:5px'>${replacelanguage}</span><span>${replacedate}</span></p><p class="description">${replacdescription}</p></div></div>`;
          return popoverHtml;
        });
      }
      if (this.answerContent) {
        // const regex = /\[refer(.*?)\]/g;
        const regex = /\[refer(\d+)\]/g;
        let match;
        this.answerContent = this.answerContent.replace(regex, (match, p1) => {
          const middleText = parseInt(p1) - 1;
          // 添加索引越界保护
          if (!this.referenceContent[middleText]) {
            console.error(`Invalid reference index: ${middleText}`);
            return match; // 返回原文本避免破坏内容
          }
          const author = this.referenceContent[middleText].author ? this.referenceContent[middleText].author.slice(0, 5) : "";
          const date = this.referenceContent[middleText].publish_date ? this.referenceContent[middleText].publish_date.split("-")[0] : "";
          const replaceText = author + "..." + date;
          const replacetitle = this.referenceContent[middleText]?.title;
          const replaceauthor = this.referenceContent[middleText].author ? this.referenceContent[middleText].author : "";
          const replaceurl = this.referenceContent[middleText]?.url;
          const replacelanguage = this.referenceContent[middleText].language ? this.referenceContent[middleText].language : "";
          const replacedate = this.referenceContent[middleText].publish_date ? this.referenceContent[middleText].publish_date : "";
          const replacdescription = this.referenceContent[middleText]?.description;
          const popoverHtml = `<div class='show'><span class='linecolor'>${replaceText}</span><div class="hidetext"><p class="title" data-url="${replaceurl}">${replacetitle}</p><p class="detail"><span class='line2' style='padding-right:5px;font-weight: normal;'>${replaceauthor}</span><span style='padding-right:5px'>${replacelanguage}</span><span>${replacedate}</span></p><p class="description">${replacdescription}</p></div></div>`;
          // const popoverHtml = `<div class='show' @mouseenter="positionHidetext">
          //   <span class='linecolor'>${replaceText}</span>
          //   <div class="hidetext" :style="{ top: hidetextTop + 'px', left: hidetextLeft + 'px' }">
          //     <p class="title" data-url="${replaceurl}">${replacetitle}</p>
          //     <p class="detail">
          //       <span class='line2' style='padding-right:5px;font-weight: normal;'>${replaceauthor}</span>
          //       <span style='padding-right:5px'>${replacelanguage}</span>
          //       <span>${replacedate}</span>
          //     </p>
          //     <p class="description">${replacdescription}</p>
          //   </div>
          // </div>`;
          // const popoverHtml = `<span><span class='linecolor'>${replaceText}</span><span class='hidetext'>${replacetitle}</span></span>`;
          // this.answerContent = this.answerContent.replace(
          //   `[refer${middleText}]`,
          //   popoverHtml
          return popoverHtml;
        });
      }
      this.$nextTick(() => {
        const thinkContentDiv = this.$refs.thinkContent;
        const answerContentDiv = this.$refs.answerContent;
        if (thinkContentDiv) {
          thinkContentDiv.addEventListener("click", event => {
            this.hideAllHidetext();
            if (event.target.classList.contains("linecolor")) {
              event.stopPropagation(); // 阻止事件冒泡
              const hidetext = event.target.nextElementSibling;
              if (hidetext) {
                hidetext.style.display = hidetext.style.display === "none" ? "block" : "none";
              }
            } else if (event.target.classList.contains("title")) {
              event.stopPropagation();
              const url = event.target.dataset.url;
              if (url) {
                this.tourl(url);
              }
            }
          });
        }
        if (answerContentDiv) {
          answerContentDiv.addEventListener("click", event => {
            this.hideAllHidetext();
            if (event.target.classList.contains("linecolor")) {
              event.stopPropagation(); // 阻止事件冒泡
              const hidetext = event.target.nextElementSibling;
              if (hidetext) {
                hidetext.style.display = hidetext.style.display === "none" ? "block" : "none";
              }
            } else if (event.target.classList.contains("title")) {
              event.stopPropagation();
              const url = event.target.dataset.url;
              if (url) {
                this.tourl(url);
              }
            }
          });
        }
        document.addEventListener("click", event => {
          const isInsideThinkContent = thinkContentDiv && thinkContentDiv.contains(event.target);
          const isInsideanswerContent = answerContentDiv && answerContentDiv.contains(event.target);
          const isLinecolor = event.target.classList.contains("linecolor");
          const isHidetext = event.target.classList.contains("hidetext");

          if ((!isInsideThinkContent || (!isLinecolor && !isHidetext)) && !isInsideanswerContent) {
            this.hideAllHidetext();
          }
        });
      });
      // this.positionHidetext();
    },
    positionHidetext(event) {
      const trigger = event.target.closest(".show");
      const hidetext = trigger?.querySelector(".hidetext");
      if (hidetext) {
        const rect = trigger.getBoundingClientRect();
        hidetext.style.top = `${rect.top + window.scrollY}px`;
        hidetext.style.left = `${rect.left + window.scrollX}px`;
      }
    },
    // positionHidetext(event) {
    //   const trigger = event.target;
    //   const hidetext = trigger.nextElementSibling;
    //   if (hidetext) {
    //     const rect = trigger.getBoundingClientRect();
    //     hidetext.style.setProperty("--hidetext-top", `${rect.bottom}px`);
    //     hidetext.style.setProperty("--hidetext-left", `${rect.left}px`);
    //   }
    // },
    // 新添加一个方法用于隐藏所有的.hidetext 元素
    hideAllHidetext() {
      const hidetexts = document.querySelectorAll(".hidetext");
      hidetexts.forEach(hidetext => {
        hidetext.style.display = "none";
      });
    },
    scrolldown() {
      if (!this.isScrolling) {
        const box = this.$refs.box;
        if (box) {
          box.scrollTop = box.scrollHeight;
        }
      }
    },
    answer() {
      this.reference_load = true;
      this.process_load = true;
      this.isScrolling = false;
      if (sessionStorage.getItem("search-id")) {
        this.conversation_id = sessionStorage.getItem("search-id");
      } else {
        return;
      }
      this.$http({
        url: "api/v1/resource/ai-academic/select?conversationId=" + this.conversation_id,
        method: "GET",
      }).then(res => {
        if (res.code == 1) {
          this.askload = true;
          let newanswertext = res.data.answer.replace("</answer_finished>", "");
          this.answerContent = newanswertext;
          this.referenceContent = res.data.reference;
          this.thinkContent = res.data.thinking;
          this.questionContent = res.data.question;
          this.searchContent = res.data.search;
          this.answertrue = true;
          this.reference_load = false;
          this.process_load = false;
          this.history_load = false;
          this.wantask();
          this.handleScroll();
          this.linktext();
        }
      });
    },
    beforeDestroy() {
      clearInterval(this.timer);
    },
    getask(asktext, question, idx) {
      this.selectedIndex = idx;
      this.hotlist = "";
      this.questionContent = "";
      this.processContent = "";
      this.searchContent = "";
      this.referenceContent = "";
      this.thinkContent = "";
      this.answerContent = "";
      this.answertrue = false;
      // sessionStorage.removeItem("search-answers");
      // sessionStorage.setItem("search-answers", JSON.stringify(question));
      sessionStorage.removeItem("search-id");
      sessionStorage.setItem("search-id", JSON.stringify(asktext));
      this.answer();
    },
    getInfo() {
      this.$http({
        url: "api/v1/user/info",
        method: "POST",
      }).then(res => {
        this.username = res.data.userName;
        let keyword = decodeURIComponent(this.$route.query.keyword || "");
        if (keyword) {
          sessionStorage.removeItem("search-answers");
          sessionStorage.setItem("search-answers", JSON.stringify(keyword));
          this.history(1);
          this.stream_chat();
        } else if (sessionStorage.getItem("search-answers")) {
          this.history(1);
          this.stream_chat();
        } else {
          // 当两者都没有时，获取历史记录后处理最后一条
          this.history(1).then(() => {
            if (this.historylist.length > 0) {
              const lastItem = this.historylist[this.historylist.length - 1];
              this.getask(lastItem.conversation_id, lastItem.question, this.historylist.length - 1);
            }
          });
        }
      });
    },
    history(index) {
      return this.$http({
        // 添加 return
        url: "api/v1/resource/ai-academic/history",
        method: "GET",
      }).then(res => {
        if (res.code == 1) {
          this.history_load = false;
          this.historylist = res.data;
          if (index) {
            this.selectedIndex = 100;
          } else {
            this.selectedIndex = res.data.length - 1;
          }
        }
        return res.data;
      });
    },
    wantask() {
      this.$http({
        url: "api/v1/resource/ai-academic/questionExtend",
        method: "GET",
      }).then(res => {
        if (res.code == 1) {
          this.hotlist = res.data;
          this.scrolldown();
        }
      });
    },
    toSearch(hotitem) {
      if (hotitem) {
        this.keyword = hotitem;
      } else {
        if (!this.keyword.trim()) {
          this.$message.error("请输入检索词");
          return;
        }
      }
      this.selectedIndex = 100;
      sessionStorage.removeItem("search-answers");
      sessionStorage.setItem("search-answers", JSON.stringify(this.keyword));
      this.keyword = "";
      this.hotlist = "";
      this.questionContent = "";
      this.processContent = "";
      this.searchContent = "";
      this.referenceContent = "";
      this.thinkContent = "";
      this.answerContent = "";
      this.answertrue = false;
      this.stream_chat();
    },
    tourl(url) {
      window.open(url, "_self");
    },
    updateHidetextPosition() {
      const box = this.$refs.box;
      const leftPanelWidth = document.querySelector(".left")?.offsetWidth || 230;
      const hidetexts = box.querySelectorAll(".hidetext");
      hidetexts.forEach(hidetext => {
        const trigger = hidetext.previousElementSibling;
        if (trigger && trigger.classList.contains("linecolor")) {
          const rect = trigger.getBoundingClientRect();
          const scrollLeft = box.scrollLeft;
          const scrollTop = box.scrollTop;

          hidetext.style.top = `${rect.top - 50}px`;
          hidetext.style.left = `${rect.left - leftPanelWidth + scrollLeft - 10}px`;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.askcontainer {
  width: 100%;
  height: calc(100vh - 74px);
  display: flex;
  .max_height {
    max-height: calc(100vh - 74px);
    overflow-y: auto;
  }
  .left {
    width: 23%;
    background: #fff;
    padding: 30px 50px;
    ::v-deep .el-timeline-item.selected .el-timeline-item__node {
      // 为选中的 el-timeline-item 设置样式
      background-color: #2d8cf0; // 选中时的背景颜色
      border-radius: 8px;
    }
    ::v-deep .el-timeline-item.selected .asklist {
      color: #2d8cf0;
    }
  }
  .middle {
    width: 52%;
    margin: 0px 1%;
    padding: 30px 50px;
    background: #fff;
    position: relative;
    .message {
      max-height: calc(100vh - 180px);
      // overflow: hidden;
      overflow-y: auto;
      line-height: 36px;
      .questionContent {
        width: 100%;
        min-height: 60px;
        background: #f2f9fa;
        align-items: center;
        padding: 0px 30px;
        display: flex;
        margin-bottom: 20px;
        div {
          min-width: 98px;
        }
        span {
          font-weight: bold;
        }
      }
      .thinkContent {
        background: #f2f9fa;
        width: 80%;
        padding: 20px;
        margin-bottom: 20px;
      }
      .processContent,
      .search-title {
        margin: 18px 0px;
      }
      .search-title {
        font-size: 20px;
        font-weight: bold;
      }
    }
    .askinput {
      width: 100%;
      height: 60px;
      border: 1px solid #c2eef2;
      border-radius: 10px;
      box-shadow: 2.83px 2.83px 12px 4px rgba(27, 180, 182, 0.15);
      // position: relative;
      // bottom: 10px;
      .serachbtn {
        position: absolute;
        margin-left: 8px;
        margin-top: 14px;
        cursor: pointer;
      }
      // ::v-deep .el-input__inner {
      //   width: 100%;
      //   height: 60px;
      //   background: #ffffff;
      // }
    }
    ::v-deep .el-input {
      width: calc(100% - 60px);
    }
    ::v-deep .el-input__inner {
      border: none;
      background: none;
      height: 60px;
      padding-right: 80px;
      font-size: 18px;
    }
    .answerContent {
      padding-bottom: 35px;
      border-bottom: 1px dashed #cccccc;
    }
    .processContent {
      ::v-deep .el-loading-spinner .circular {
        width: 25x; // 自定义加载动画的宽度
        height: 25px; // 自定义加载动画的高度
        margin-top: 25px;
      }
    }
    .tip_title {
      padding-top: 35px;
      font-weight: bold;
    }
    .tip_qustion {
      margin-top: 10px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .tip_list {
        width: 48%;
        margin-bottom: 15px;
        background: #f2f9fa;
        background: #f2f9fa;
        padding: 2px 20px;
        span {
          cursor: pointer;
          color: #666666;
        }
        span:hover {
          color: #2d8cf0;
        }
      }
    }
    a,
    .url {
      text-decoration: underline;
      color: #2d8cf0;
      cursor: pointer;
    }
  }
  .right {
    width: 23%;
    background: #fff;
    padding: 30px 50px;
    ul {
      margin-bottom: 25px;
    }
    li {
      margin-bottom: 5px;
    }
    .booktitle {
      font-weight: bold;
      font-size: 18px;
      margin-top: 15px;
      cursor: pointer;
    }
    .booktitle:hover {
      color: #2d8cf0;
    }
    .listtext {
      font-size: 16px;
      padding: 8px 0px;
      span {
        padding-right: 10px;
      }
    }
    .description {
      color: #999;
    }
    .url {
      text-decoration: underline;
      color: #2d8cf0;
      cursor: pointer;
    }
  }
  ::-webkit-scrollbar {
    display: block;
    width: 3px; /* 定制滚动条的宽度 */
  }
  /* 定制滚动条滑块样式 */
  ::-webkit-scrollbar-thumb {
    background-color: #2d8cf0;
  }
  .asklist {
    font-size: 16px;
    cursor: pointer;
  }
  .asklist:hover {
    color: #2d8cf0;
  }
  .title {
    font-size: 18px;
    font-weight: bold;
    padding-bottom: 20px;
  }
}
// .linecolor {
//   text-decoration: underline !important;
//   color: #2d8cf0 !important;
// }
// .linecolor:hover .hidetext {
//   display: show !important;
// }
// .hidetext {
//   display: none !important;
// }
.linecolor {
  color: #2d8cf0;
  text-decoration: underline;
  cursor: pointer;
}

.hidetext {
  display: none;
  z-index: 9999;
  margin-top: 5px; // 添加间距防止遮挡
  position: absolute; // 从fixed改为absolute
}

.linecolor:hover + .hidetext {
  display: inline;
}
.line5 {
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 5;
  /* -webkit-box-orient: vertical; */
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  /* autoprefixer: on */
  display: -webkit-box;
  word-break: break-all;
}
.disabled-item {
  opacity: 0.6;
  cursor: not-allowed !important;

  .asklist {
    pointer-events: none;
    color: #999 !important;

    &:hover {
      color: #999 !important;
    }
  }
}
</style>
